import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=8aa33d90&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=8aa33d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa33d90",
  null
  
)

export default component.exports